export const getFormatForUrlByArray = (array, preparedReturnValueFunc) => {
    if (!array.length) {
        return undefined;
    }

    return preparedReturnValueFunc(array);
};